import React, { ReactNode, useState } from 'react'

import { Tag } from 'antd'

const { CheckableTag } = Tag

interface CheckableTagProps {
  checked: boolean
  allowChange?: boolean
  onChange?: (checked: boolean) => void
  children: ReactNode
}

const Display = (props: CheckableTagProps) => {
  const [checked, setChecked] = useState(props.checked)

  const onChange = (checked: boolean) => {
    if (props.allowChange) {
      setChecked(checked)
      if (props.onChange) {
        props.onChange(checked)
      }
    }
  }

  return (
    <CheckableTag checked={checked} onChange={onChange}>
      {props.children}
    </CheckableTag>
  )
}

export default Display
